// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { bannerStyles } from "@ces/Overrides/Widgets/Basic/Banner";
import LinkArrowRight from "@ces/XDL/Icons/LinkArrowRight";
import { getSystemColor, xScreen } from "@ces/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

bannerStyles.mainContainer = {
    css: css`
        height: 100%;
        display: flex;
        flex-direction: ${({ isReversedImage }: any) => (isReversedImage ? "row" : "row-reverse")};
        gap: ${({ gapBetweenContents }: any) => `${gapBetweenContents}px` || 0};

        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

bannerStyles.wrapper = {
    css: css`
        width: 100%;
        height: 100%;
        display: flex;
        border-radius: 2px;
    `,
};

bannerStyles.overlayWrapper = {
    css: css`
        width: 100%;
        color: white;
        text-align: ${({ horizontalAlignment }: any) => horizontalAlignment};
        max-width: ${({ maxContentWidth }: any) => `${maxContentWidth}%`};

        ${xScreen("lte", "md")} {
            max-width: ${({ isResponsiveImage }: any) => (isResponsiveImage ? "40%" : "100%")};
            padding: ${({ isContentStretched }: any) => (isContentStretched ? 0 : "20px 16px 32px")};
        }

        ${xScreen("lt", "md")} {
            max-width: 100%;
        }
    `,
};

bannerStyles.mainContentWrapper = {
    css: css`
        width: ${({ maxBannerContainerWidth }: any) => maxBannerContainerWidth || "100%"};

        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

bannerStyles.mainImageWrapper = {
    css: css`
        width: ${({ maxImageContainerWidth }: any) => maxImageContainerWidth || "100%"};

        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

bannerStyles.mainImage = {
    css: css`
        &&&,
        &&& > picture {
            display: flex;
            height: 100%;
            width: 100%;

            img {
                width: 100%;
                height: 100%;
            }
        }
    `,
};

bannerStyles.contentWrapper = {
    css: css`
        ${({ isContentStretched }: any) =>
            isContentStretched && {
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
            }}
    `,
};

bannerStyles.bannerTitle = {
    css: css`
        ${TypographyStyle} {
            margin: ${({ disableButton }: any) => (disableButton ? "0 0 12px" : "0 0 16px")};

            ${xScreen("lte", "md")} {
                span {
                    color: ${getSystemColor("text.main")} !important; /* Override cms  */
                }
            }
        }
    `,
};

bannerStyles.bannerDescription = {
    css: css`
        ${TypographyStyle} {
            margin: ${({ disableButton }: any) => (disableButton ? 0 : "0 0 16px")};

            ${xScreen("lte", "md")} {
                span {
                    color: ${getSystemColor("common.ui6")} !important; /* Override cms  */
                }
            }
        }
    `,
};

bannerStyles.bannerLink = {
    icon: {
        position: "right",
        iconProps: {
            src: LinkArrowRight,
            size: 14,
        },
    },
    typographyProps: {
        size: 16,
        lineHeight: "17px",
    },
    css: css`
        ${TypographyStyle}, ${IconWrapper} {
            color: ${({ linkColor }: any) => linkColor};
        }
        margin-top: 4px;
    `,
};

bannerStyles.bannerButton = {
    css: css`
        width: fit-content;
        margin-top: 4px;
    `,
};
